<div
  class="element-wrapper {{ elementActionsKeyRoot }} {{ elementActionsKey }}"
  [ngStyle]="wrapperStyles"
>
  <div class="header">
    <blaze-element-filter-header
      [addButtonBlocked]="!itemAddEnabled"
      [addButtonCssClasses]="getActionClasses(itemAddStyleSheetTargetOrId)"
      [addButtonEnabled]="itemAddEnabled"
      [addButtonLabel]="itemAddLabel"
      [fontColor]="props?.style?.title?.text?.color1"
      [labelEnabled]="labelEnabled"
      [labelFontFamily]="props?.style?.titleBlock?.fontFamily"
      [labelFontSize]="props?.style?.titleBlock?.fontSize"
      [labelFontStyle]="props?.style?.titleBlock?.fontStyle"
      [labelFontWeight]="props?.style?.titleBlock?.fontWeight"
      [labelIconAlign]="props?.content?.title?.iconPosition"
      [labelIconSize]="props?.style?.titleBlock?.iconSize"
      [labelIconColor]="props?.content?.title?.iconColor?.color1"
      [labelIcon]="icon"
      [labelTextAlign]="props?.content?.title?.align"
      [labelText]="labelText"
      [searchAndFilters]="props?.content?.searchAndFilters"
      [slots]="slots"
      (addButtonClick)="onAddNewRow($event)"
    />
  </div>

  <div class="chart-wrapper">
    @if (model$$ | async; as model) {
      <div
        #scroll
        class="chart-container"
        [ngClass]="{
          placeholder: !hasBoundValue,
          borderless,
          'item-view-enabled': itemViewEnabled,
          'item-edit-enabled': itemEditEnabled,
        }"
      >
        @if (model.categories.length === 0 && hasBoundValue && (isLoading$ | async) === false) {
          <div class="no-data">
            <span>No Data</span>
          </div>
        }
        @if (model.categories.length > 0) {
          <div class="row heading">
            <div #headingTask class="task">
              @if (model.withCategories) {
                <div class="button-wrapper">
                  <div class="border-wrapper"></div>
                  <button
                    class="collapse-all"
                    (click)="collapseAll()"
                    data-cy="GanttChart:collapseAll"
                  >
                    <mat-icon
                      [svgIcon]="
                        model.collapsedCategories.size < model.categories.length
                          ? 'icon_row_behavior_collapse_16'
                          : 'icon_row_behavior_expand_16'
                      "
                    />
                  </button>
                </div>
              }
              @if (!model.withCategories) {
                <div></div>
              }
              <div class="button-wrapper">
                <div class="border-wrapper"></div>
                <button class="today" (click)="showToday()" [disabled]="!model.now"> TODAY </button>
              </div>
              <be-gantt-chart-resize-column (resizeColumn)="onResizeColumn($event)" />
            </div>
            @for (column of model.columns; let i = $index; track i) {
              <div
                class="entry"
                [attr.data-cy]="model.now && model.now.column === i ? 'GanttChart:entryNow' : null"
              >
                <div class="title">{{ column.label }}</div>
                @if (hasDays) {
                  <div class="days">
                    @for (day of column.days; track day.label) {
                      <span class="day" [class.weekend]="day.weekend">{{ day.label }}</span>
                    }
                  </div>
                }
                @if (model.now && model.now.column === i) {
                  <div
                    #now
                    class="now"
                    [style.left]="
                      'calc(var(--b-gc-header-width) + ' +
                      (model.now.column + model.now.pos) +
                      ' * var(--b-gc-cell-width) - 1px)'
                    "
                  >
                    <mat-icon svgIcon="icon_gantt_triangle_8" class="top" />
                    <mat-icon svgIcon="icon_gantt_triangle_8" class="bottom" />
                  </div>
                }
              </div>
            }
          </div>
        }
        @for (category of model.categories; track trackByCategory($index, category)) {
          @if (model.withCategories) {
            <div class="row category">
              <div class="task">
                <button
                  class="expander"
                  (click)="collapseCategory(category.id)"
                  data-cy="GanttChart:collapse"
                >
                  <mat-icon
                    [svgIcon]="
                      model.collapsedCategories.has(category.id)
                        ? 'icon_chevron_right_8'
                        : 'icon_chevron_down_8'
                    "
                  />
                </button>
                <span
                  class="name text-ellipsed"
                  [blazeTooltip]="category.label"
                  data-cy="GanttChart:task"
                >
                  {{
                    category.label | formatValue: categoryFieldFormat : categoryFieldFormatOptions
                  }}
                </span>
                <be-gantt-chart-resize-column (resizeColumn)="onResizeColumn($event)" />
              </div>
              <ng-container
                *ngTemplateOutlet="
                  entryRenderer;
                  context: { entry: category, categoryId: category.id }
                "
              />
            </div>
          }
          <div class="category-container" [@collapsed]="model.collapsedCategories.has(category.id)">
            @for (entry of category.entries; track trackByTask($index, entry)) {
              <div
                class="row"
                [class.selected]="model.selectedId !== undefined && model.selectedId === entry.id"
                (click)="onEntryClick($event, entry)"
              >
                <div class="actions-container">
                  <div class="actions">
                    <button
                      type="button"
                      class="action-btn view-row"
                      [ngClass]="getActionClasses(itemViewStyleSheetTargetOrId)"
                      (click)="onViewRow($event, entry)"
                      blazeTooltip="View"
                      matTooltipPosition="above"
                      data-cy="GanttChart:rowView"
                    >
                      <mat-icon svgIcon="icon_preview_16" class="bd-btn-icon" />
                    </button>
                    <button
                      type="button"
                      class="action-btn edit-row"
                      [ngClass]="getActionClasses(itemEditStyleSheetTargetOrId)"
                      (click)="onEditRow($event, entry)"
                      blazeTooltip="Edit"
                      matTooltipPosition="above"
                      data-cy="GanttChart:rowEdit"
                    >
                      <mat-icon svgIcon="icon_edit_24" class="bd-btn-icon" />
                    </button>
                  </div>
                </div>
                <div class="task">
                  @if (model.withCategories) {
                    <div class="expander"></div>
                  }
                  <span class="name text-ellipsed" [blazeTooltip]="entry.task ?? ''">
                    {{ entry.task | formatValue: taskFieldFormat : taskFieldFormatOptions }}
                  </span>
                  @let custom = entry.custom$ | async;
                  @if (custom?.length) {
                    <span class="custom-fields">
                      @for (field of custom; track field; let i = $index) {
                        <span class="value">
                          @switch (field.displayFormat ?? field.format) {
                            @case ('tag') {
                              <blaze-tags-column-value
                                class="tags"
                                [value]="field | dataRowFieldValuePipe: 'value'"
                                [palette]="tagConfig[i]?.palette"
                                [order]="tagConfig[i]?.order"
                                [tooltipHeader]="field.label"
                              />
                            }
                            @case ('file') {
                              <blaze-file-column-value
                                class="files"
                                [value]="field | dataRowFieldValuePipe: 'value'"
                                [isSecure]="isFieldSecure(field)"
                                [blazeTooltip]="field.label"
                              />
                            }
                            @case ('image') {
                              <img
                                [src]="field | dataRowFieldValuePipe: 'value'"
                                [blazeTooltip]="field.label"
                              />
                            }
                            @case ('signature') {
                              <blaze-signature-column-value
                                [signature]="$any(field | dataRowFieldValuePipe: 'value')"
                                [blazeTooltip]="field.label"
                              />
                            }
                            @default {
                              @let value =
                                field
                                  | dataRowFieldValuePipe: 'value'
                                  | formatValue
                                    : field.displayFormat || 'text'
                                    : {
                                        precision: field.precision,
                                        currency: field.currency,
                                        durationFormat: field.duration || 'h:mm',
                                        dateFormat: field.dateFormat,
                                        dateTimeFormat: field.dateTimeFormat,
                                      };
                              <span
                                class="text text-ellipsed format-{{ field.displayFormat }}"
                                [blazeTooltip]="field.label"
                                matTooltipPosition="above"
                                matTooltipClass="whitespace-pre-wrap"
                                (click)="onCustomFieldClick(field)"
                              >
                                {{ value }}
                              </span>
                            }
                          }
                        </span>
                      }
                    </span>
                  }
                  <be-gantt-chart-resize-column (resizeColumn)="onResizeColumn($event)" />
                </div>
                <ng-container
                  *ngTemplateOutlet="entryRenderer; context: { entry, categoryId: category.id }"
                />
              </div>
            }
          </div>
        }
        <ng-template #entryRenderer let-entry="entry" let-categoryId="categoryId">
          @for (column of entry.cells; track trackByIndex(i, column); let i = $index) {
            <div class="entry">
              @if (entry.column === i) {
                <div
                  class="bar"
                  [style]="categoryStyles[categoryId ?? '']"
                  [style.left]="percent(entry.start ?? 0)"
                  [style.width]="
                    'calc(' +
                    percent(entry.length ?? 0) +
                    ' + ' +
                    (borderless ? -1 : (entry.buckets ?? 0) - 1) +
                    ' * var(--b-gc-border-width))'
                  "
                  [blazeTooltip]="entry.tooltip ?? ''"
                  matTooltipPosition="above"
                  matTooltipClass="gantt-chart-tooltip"
                ></div>
              }
            </div>
          }
        </ng-template>
      </div>
    }
  </div>
</div>
